import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RanConfigurationDto } from "../../models/ran-configuration/ran-configuration-dto";
import { BandOption } from "../../models/ran-configuration/band-option";
import { BandCreateConfigurationComponent } from './gnb-configuration/band-create-configuration/band-create-configuration.component';
import { BandwidthUSRPCreateConfigurationComponent } from './gnb-configuration/bandwidth-create-configuration/bandwidth-create-configuration.component';
import { TddCreateConfigurationComponent } from './gnb-configuration/tdd-create-configuration/tdd-create-configuration.component';
import { ModulationOrderUSRPCreateConfigurationComponent } from './gnb-configuration/modulation-order-create-configuration/modulation-order-create-configuration.component';
import { MimoUSRPCreateConfigurationComponent } from './gnb-configuration/mimo-create-configuration/mimo-create-configuration.component';

@Component({
    selector: 'oaibox-ran-configuration-form',
    templateUrl: './ran-configuration-form.component.html',
    styleUrls: ['./ran-configuration-form.component.css'],
    imports: [BandCreateConfigurationComponent, BandwidthUSRPCreateConfigurationComponent, TddCreateConfigurationComponent, ModulationOrderUSRPCreateConfigurationComponent, MimoUSRPCreateConfigurationComponent]
})
export class RanConfigurationFormComponent {

  @Input() public editableRanConfiguration?: RanConfigurationDto;
  @Input() public defaultRanConfiguration?: RanConfigurationDto;
  @Output() public ranConfigurationChanges: EventEmitter<RanConfigurationDto> = new EventEmitter();

  constructor() { }

  public getCleanRanConfiguration(): RanConfigurationDto {
    return {
      mimoOptions: [],
      band: [],
      bandwidth: [],
      modulationOrder: {
        downlinkOptions: [],
        uplinkOptions: [],
      },
      tdd: [],
    };
  }

  public updateBand(bandOptions: BandOption[]): void {
    if (!this.editableRanConfiguration) this.editableRanConfiguration = this.getCleanRanConfiguration();
    this.editableRanConfiguration.band = bandOptions;

    this.ranConfigurationChanges.emit(this.editableRanConfiguration);
  }

  public updateBandwidth(bandwidthOptions: number[]): void {
    if (!this.editableRanConfiguration) this.editableRanConfiguration = this.getCleanRanConfiguration();
    this.editableRanConfiguration.bandwidth = bandwidthOptions;

    this.ranConfigurationChanges.emit(this.editableRanConfiguration);
  }

  public updateMimoConfiguration(mimoOptions: string[]): void {
    if (!this.editableRanConfiguration) this.editableRanConfiguration = this.getCleanRanConfiguration();
    if (!this.editableRanConfiguration.mimoOptions) this.editableRanConfiguration.mimoOptions = [];
    this.editableRanConfiguration.mimoOptions = mimoOptions;

    this.ranConfigurationChanges.emit(this.editableRanConfiguration);
  }

  public updateModulationOrderDownlink(modulationOrder: string[]): void {
    if (!this.editableRanConfiguration) this.editableRanConfiguration = this.getCleanRanConfiguration();
    if (!this.editableRanConfiguration.modulationOrder) this.editableRanConfiguration.modulationOrder = {};
    this.editableRanConfiguration.modulationOrder.downlinkOptions = modulationOrder;

    this.ranConfigurationChanges.emit(this.editableRanConfiguration);
  }

  public updateModulationOrderUplink(modulationOrder: string[]): void {
    if (!this.editableRanConfiguration) this.editableRanConfiguration = this.getCleanRanConfiguration();
    if (!this.editableRanConfiguration.modulationOrder) this.editableRanConfiguration.modulationOrder = {};
    this.editableRanConfiguration.modulationOrder.uplinkOptions = modulationOrder;

    this.ranConfigurationChanges.emit(this.editableRanConfiguration);
  }

  public updateTdd(tdd: string[]): void {
    if (!this.editableRanConfiguration) this.editableRanConfiguration = this.getCleanRanConfiguration();
    this.editableRanConfiguration.tdd = tdd;

    this.ranConfigurationChanges.emit(this.editableRanConfiguration);
  }

  public updateFDDBandwidth(fddBandwidthOptions: number[]): void {
    if (!this.editableRanConfiguration) this.editableRanConfiguration = this.getCleanRanConfiguration();
    this.editableRanConfiguration.fddBandwidth = fddBandwidthOptions;

    this.ranConfigurationChanges.emit(this.editableRanConfiguration);
  }

}
